import {
	comMapping
} from '../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "shenbq",
				label: '申报期',
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				prop: "fapdm",
				label: '发票代码',
				type: "input"
			},
			{
				prop: "faphm",
				label: '发票号码',
				type: "input",
			},
			{
				prop: "kaiprq",
				label: '开票日期',
				type: "datemonth",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "kaiplx",
				label: '开票类型',
				type: "select",
				selectval: comMapping.$Faplx
			},

		],
		searchdata: {
			companyCode: "",
			shenbq: "",
			fapdm: "",
			other: "",
			faphm: "",
			kaiprq: "",
			Total: '',
			before: '',
			tax: '',
			sign: '',
			Bookkeeping: '',
			Deduction: '',
			credit: '',
			hansje: "",
		},
		headData: [{
				title: "公司代码",
				prop: "companyCode",
				width: 80
			},
			{
				title: "申报期",
				prop: "shenbq",
				width: 80
			},
			{
				title: "发票代码",
				prop: "fapdm",
				// custom:true,
				width: 110
			},
			{
				title: "发票号码",
				prop: "other",
				width: 80
			},

			{
				title: "开票日期",
				prop: "faphm",
				// custom:true,
				width: 80
			},
			{
				title: "开票类型",
				prop: "kaiprq",
				// custom:true,
				width: 80
			},
			{
				title: "含税金额合计",
				prop: "Total",
				// custom:true,
				width: 110
			}, {
				title: "未税金额合计",
				prop: "before",
				// custom:true,
				width: 110
			}, {
				title: "税额合计",
				prop: "tax",
				// custom:true,
				width: 80,
				AmountFormat: true,
				align: "right"
			}, {
				title: "标志",
				prop: "sign",
				// custom:true,
				width: 80
			}, {
				title: "记账标志",
				prop: "Bookkeeping",
				// custom:true,
				width: 80
			}, {
				title: "抵扣标志",
				prop: "Deduction",
				// custom:true,
				width: 80
			}, {
				title: "抵扣税额",
				prop: "credit",
				// custom:true,
				width: 80
			},
			{
				title: "批次号",
				prop: "hansje",
				width: 160,
				align: "left"
			},

		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
